import { Controller } from '@hotwired/stimulus'

// Быстрый выбор времени в форме добавления тренировок: чипы «08:00 09:00 …»
// добавляют время в поле «Время начала» или убирают его оттуда. Поле
// остаётся обычным текстом — можно дописать 18:30 руками, чипы подсветятся
// по тому, что в нём написано. С телефона это вместо набора «09:00, 10:00»
// на клавиатуре.
export default class TimesPickerController extends Controller {
  static targets = ['input', 'chip']

  connect() {
    this.sync()
  }

  toggle(event) {
    const time = event.params.time
    const times = this.times()
    const index = times.indexOf(time)
    if (index >= 0) times.splice(index, 1)
    else times.push(time)
    times.sort()
    this.inputTarget.value = times.join(', ')
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.sync()
  }

  sync() {
    const times = this.times()
    this.chipTargets.forEach((chip) => {
      const active = times.includes(chip.dataset.time)
      chip.setAttribute('aria-pressed', String(active))
      chip.classList.toggle('bg-bg-blue-subtle', active)
      chip.classList.toggle('border-text-blue', active)
      chip.classList.toggle('text-text-blue', active)
    })
  }

  // «9:00, 18.30» → ['09:00', '18:30']: чип «09:00» должен узнать и 9:00.
  times() {
    return this.inputTarget.value
      .split(/[\s,;]+/)
      .map((token) => token.trim().replace('.', ':'))
      .filter((token) => /^\d{1,2}:\d{2}$/.test(token))
      .map((token) => token.padStart(5, '0'))
  }
}
